import NewLocation from './NewLocation';

export default NewLocation;
